/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_StorageInputs */

const en_admin_settings_tabs_storage = /** @type {(inputs: Admin_Settings_Tabs_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

const zh_admin_settings_tabs_storage = /** @type {(inputs: Admin_Settings_Tabs_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Admin_Settings_Tabs_StorageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_storage = /** @type {((inputs?: Admin_Settings_Tabs_StorageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_StorageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_storage(inputs)
	return zh_admin_settings_tabs_storage(inputs)
});
export { admin_settings_tabs_storage as "admin.settings.tabs.storage" }